import {observable, action , toJS} from 'mobx'
import _ from 'lodash';
import {doGet, doPost, doPut} from './AjaxRequests';
import swal from 'sweetalert';

class AppStore{

    @observable
    postData={
        txtUse:"",
        DonationAmount:"",
        txtName:"",
        txtIdentify:"",
        txtPhone:"",
        txtTitle:"",
        radIsReceipt:"",
        txtZip:"",
        txtAddress:"",
        ShortDesc:"",
        url:"https://official.kfsyscc.org/donate/result2.aspx"
    }

    @observable
    zipSelections = []


    

    @observable
    zipSelectedCity = ''

    @observable
    captcha = {
        text:"",
        link:"",
        verifyCode:""
    }

    @observable
    postCTBCData = {
        merID:"",
        URLEnc:""
    }

    
    

    constructor(){        
        this.changeCaptchaImage()
        this.getZipCodeData()        
    }

    getZipCodeData(){
        fetch("https://www.kfsyscc.org/normal_api/service", {            
            method: 'POST',
            body: JSON.stringify({api:'TWZip'}),
            headers: {'content-type': 'application/json'}
        })
        .then(function (response) {
            return response.json();
        })
        .then((data) => {            
            this.zipSelections = data.data    
            this.setZipSelectedValue('臺北市', 'city')                           
        })
        .catch((e)=>{
            console.log(e);
            swal("系統錯誤")
        })        
    }

    @action
    setRadioGroupValue(val, objectKey){
        this.postData[objectKey] = val;       
    }

    @action
    setTextFieldValue(val, objectKey){
        
        
        if(objectKey=='DonationAmount'){
            if((isNaN(val) || val%1 !== 0 || val<= 0) && val!==""){
                swal("請輸入正整數", "", "error")
                return;
            }            
        }else if(objectKey=='txtName'){

        }else if(objectKey=='txtIdentify'){
            
            if(!/^[\d|a-zA-Z]+$/.test(val) && val!==""){
                swal("請輸入英文及數字","","error")
                return;
            }else{
                val = val.toUpperCase()
            }
        }else if(objectKey=='txtPhone'){
            if((isNaN(val) || val%1 !== 0) && val!==""){
                swal("請輸入數字", "", "error")
                return;
            }  
        }        
        this.postData[objectKey] = val       
    }

    setZipSelectedValue(val, type){
        if(type=='city'){
            this.zipSelectedCity = val
            let cityDistricts = _.get(_.filter(this.zipSelections, (o)=>{ return o.City == val})[0], 'Citys')                     
            this.postData.txtZip = cityDistricts[0].ZipCode
        }else if(type=='zip'){
            this.postData.txtZip = val
        }
    }

    @action
    setCaptchaTextValue(val){
        this.captcha.text = val
    }


    @action
    changeCaptchaImage(){
        let imageUrl = 'https://captcha.kfsyscc.org/ca/captcha.jpg'
        let _that = this
        const fetchGetConfig = {
            method: 'GET',
            credentials: 'include'
        }     
        fetch(imageUrl, fetchGetConfig).then((res) => {
            return res.blob()
        }).then((res) => {
            let objcetURL = URL.createObjectURL(res)                       
            _that.captcha.link = objcetURL
            fetch(`https://captcha.kfsyscc.org/ca/digits`, fetchGetConfig).then((res) => {
                return res.json()
            }).then((data) => {           
                _that.captcha.verifyCode = data.digit;  
            })
        })

    }

    @action
    summitData(){

        if(!this.postData.txtUse){
            swal("請選擇捐款用途", "", "error")
            return;
        }   
        
        let DonationAmount = this.postData.DonationAmount

        if(!DonationAmount){
            swal("請輸入捐款金額", "", "error")
            return;
        }else if((isNaN(DonationAmount) || DonationAmount%1 !== 0 || DonationAmount<= 0) && DonationAmount!==""){
            swal("捐款金額請輸入正整數", "", "error")
            return;
        }

        if(!this.postData.txtName){
            swal("請輸入捐款人姓名", "", "error")
            return;
        }

        if(!this.checkTwID(this.postData.txtIdentify)){
            swal("身分證格式錯誤", "", "error")
            return;
        }

        if(!this.postData.txtPhone){
            swal("請輸入聯絡電話", "", "error")
            return;
        }


        if(!this.postData.txtTitle){
            swal("請輸入收據抬頭", "", "error")
            return;
        }

        if(!this.postData.radIsReceipt){
            swal("請選擇收據是否郵寄", "", "error")
            return;
        }

        if(this.postData.radIsReceipt==="Y"){

            if(!this.postData.txtZip){
                swal("請選擇地址區域", "", "error")
                return;
            }
    
            if(!this.postData.txtAddress){
                swal("請輸入收據郵寄地址", "", "error")
                return;
            }
        }



        if(this.captcha.text != this.captcha.verifyCode){
            swal("驗證碼錯誤，請重新輸入", "", "error")
            this.changeCaptchaImage()
            return;
        }

         

        

        var params = 
        'url='+this.postData.url+
        '&txtUse='+this.postData.txtUse+
        '&DonationAmount='+this.postData.DonationAmount+
        '&txtName='+this.postData.txtName+
        '&txtIdentify='+this.postData.txtIdentify+
        '&txtPhone='+this.postData.txtPhone+
        '&txtTitle='+this.postData.txtTitle+
        '&radIsReceipt='+this.postData.radIsReceipt+
        '&txtZip='+this.postData.txtZip+
        '&txtAddress='+this.postData.txtAddress+
        '&ShortDesc='+this.postData.ShortDesc;
        params =  encodeURI(params);

        let _that = this

        fetch("https://official.kfsyscc.org/api/Finance/Encrypt.aspx",
        {   
            credentials: 'include',
            headers: {            
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            method: "POST",
            body: params
        })
        .then(function(response) {            
            return response.json()
        }).then(function(data) {            
           let encodeMsg = data.EncodeData
           let merID = '3001'
           _that.postCTBCData.merID = merID 
           _that.postCTBCData.URLEnc = encodeMsg
           document.getElementById("CTBCForm").submit()
        }).catch(function(err) {
            swal("系統錯誤", "", "error")                      
        })
        
    


       
        
    }

    checkTwID(id){
        //建立字母分數陣列(A~Z)
        var city = new Array(1,10,19,28,37,46,55,64,39,73,82, 2,11,20,48,29,38,47,56,65,74,83,21, 3,12,30)
        id = id.toUpperCase();
        //使用「正規表達式」檢驗格式
        if (id.search(/^[A-Z](1|2)\d{8}$/i) == -1) {
            return false;
        } else {
            //將字串分割為陣列(IE必需這麼做才不會出錯)
            id = id.split('');
            //計算總分
            var total = city[id[0].charCodeAt(0)-65];
            for(var i=1; i<=8; i++){
                total += eval(id[i]) * (9 - i);
            }
            //補上檢查碼(最後一碼)
            total += eval(id[9]);
            //檢查比對碼(餘數應為0);
            return ((total%10 == 0 ));
        }
    }
}


const appStore = new AppStore();

export default appStore;
